"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Custom = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_common_components_1 = require("@desygner/ui-common-components");
const ui_common_translation_1 = require("@desygner/ui-common-translation");
const Button_1 = require("../Button");
function Custom({ children, isDropdown, props, variant }) {
    const { t } = (0, ui_common_translation_1.useTranslation)();
    const title = t(props.titleKey);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [isDropdown && ((0, jsx_runtime_1.jsx)(ui_common_components_1.DropdownNext, { options: [
                    {
                        type: 'custom',
                        value: title,
                        children: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children }),
                    },
                ], trigger: "click", placement: "bottom", isClosedOnSelect: false, children: (0, jsx_runtime_1.jsx)(Button_1.Button, { icon: props.icon && Object.assign(Object.assign({}, props.icon), { size: 'Small' }), title: title, variant: variant, onClick: props.onUpdate }) })), !isDropdown && ((0, jsx_runtime_1.jsx)(Button_1.Button, { onClick: props.update, variant: variant, icon: props.icon && Object.assign(Object.assign({}, props.icon), { size: 'Small' }), children: children }))] }));
}
exports.Custom = Custom;
//# sourceMappingURL=Custom.js.map